import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { NewsletterPopup } from "./components/NewsletterPopup";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ServicesPage } from "./pages/ServicesPage";
import { IntakePage } from "./pages/IntakePage";
import { ShopPage } from "./pages/ShopPage";
import { ContactPage } from "./pages/ContactPage";
import { DonationPage } from "./pages/DonationPage";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        
        {/* Skip to content link for accessibility */}
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        
        <Navigation />
        
        <main id="main-content" className="flex-grow" role="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/intake" element={<IntakePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/donate" element={<DonationPage />} />
          </Routes>
        </main>
        
        <Footer />
        
        {/* Newsletter Popup - Bottom Right */}
        <NewsletterPopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
